import Box from '@eversports/klimt-primitives/legacy/Box'

import Map from '../../../../components/Map/Map'
import MapWrapper from '../../../../components/Map/MapWrapper'

interface Props {
  latitude?: number | null
  longitude?: number | null
}

const VenueMap = ({ latitude, longitude }: Props) => {
  if (!latitude || !longitude) {
    return null
  }

  const venueLocation = { latitude, longitude }
  const markers = [{ latitude, longitude }]

  return (
    <Box width="100%" height="220px" position="relative" borderRadius={1} overflow="hidden">
      <MapWrapper>
        <Map
          type="center"
          center={venueLocation}
          markers={markers}
          showGeoLocationControl={false}
          showOpenGoogleMaps={true}
          initialZoom={15}
        />
      </MapWrapper>
    </Box>
  )
}

export default VenueMap
